import { useEffect, useState, RefObject } from 'react';

export function useElementVisibility(
  ref: RefObject<Element>,
  rootMargin = '0px 0px -100% 0px',
  disabled = false
): boolean {
  const [isVisible, setIsVisible] = useState(!disabled);

  useEffect(() => {
    if (disabled) return;

    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), {
      root: null,
      threshold: 0,
      rootMargin,
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, [ref, rootMargin, disabled]);

  return isVisible;
}
